import type { MouseEvent, ReactNode } from 'react'

interface RouteLinkProps {
  href: string
  onNavigate: (path: string) => void
  children: ReactNode
  className?: string
}

export default function RouteLink({
  href,
  onNavigate,
  children,
  className,
}: RouteLinkProps) {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    onNavigate(href)
  }

  return (
    <a href={href} className={className} onClick={handleClick}>
      {children}
    </a>
  )
}
